import SanitizeHtmlDirective from '@/directives/sanitize-html';

export default {
  install(Vue) {
    Vue.directive('sanitize-html', SanitizeHtmlDirective);
  },
};
